import { CountCellProps } from '../../types';
import { pendingCreateOnMosaicStrings, pendingUpdateOnMosaicStrings } from '@constants';
import { Tooltip } from '@mui/material';
import TextWithSubtitle from 'components/TextWithSubtitle';
import { StyledCountWithSubtitleContainer } from './styles';
import { formatNumberWithComma } from 'utils';

const IntegrationServerToMosaicCountsCell = ({
  _customRowProps: { onPendingCellClick },
  pendingToMosaic,
  data,
}: CountCellProps) => {
  const { CREATE_NEW_ON_MOSAIC, UPDATE_ON_MOSAIC, dataType } = data;

  return (
    <Tooltip
      placement="top"
      title={
        <div>
          <p>Create on Mosaic: {formatNumberWithComma(+CREATE_NEW_ON_MOSAIC)}</p>
          <p>Update on Mosaic: {formatNumberWithComma(+UPDATE_ON_MOSAIC)}</p>
        </div>
      }
    >
      <StyledCountWithSubtitleContainer>
        {' '}
        <TextWithSubtitle
          mainText={formatNumberWithComma(pendingToMosaic)}
          mainTextProps={{
            onClick: pendingToMosaic
              ? () => onPendingCellClick([dataType], pendingCreateOnMosaicStrings)
              : undefined,
          }}
          mainTextClassName={+pendingToMosaic ? 'link-style clickable' : ''}
          subTitleClassName={+UPDATE_ON_MOSAIC ? 'subtitle link-style clickable' : 'subtitle'}
          subtitle={formatNumberWithComma(+UPDATE_ON_MOSAIC)}
          subtitleProps={{
            onClick: +UPDATE_ON_MOSAIC
              ? () => onPendingCellClick([dataType], pendingUpdateOnMosaicStrings)
              : undefined,
          }}
        />
      </StyledCountWithSubtitleContainer>
    </Tooltip>
  );
};

export default IntegrationServerToMosaicCountsCell;
